module.exports = __webpack_public_path__ + "img/Duplicate.97ff0f2c.svg";